export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(/^\S+@\S+\.\S+$/);
};
